import {Component, input} from '@angular/core';
import {BadgeComponent} from '../../../../../../../shared/components/badge/badge.component';
import {IconsComponent} from '../../../../../../../shared/components/icons/icons.component';
import {TooltipComponent} from '../../../../../../../shared/components/tooltip/tooltip.component';
import {CurrencyPipe, DatePipe} from '@angular/common';

@Component({
  selector: 'app-results-table-row-availability-badge-distributor',
  imports: [
    BadgeComponent,
    IconsComponent,
    TooltipComponent,
    CurrencyPipe,
    DatePipe
  ],
  templateUrl: './results-table-row-availability-badge-distributor.component.html',
  styleUrl: './results-table-row-availability-badge-distributor.component.css'
})
export class ResultsTableRowAvailabilityBadgeDistributorComponent {
  data = input.required<any>();
  price = input.required<(cost: number) => number>();
}
